<template>
  <div>
    <button
      :type='buttonType'
      class="custom-button"
      :class="{isLoading: isLoading, isDisabled: isDisabled, 'clicked': isClicked, [variant]: variant}"
      @click="handleClick"
      @mousedown="startZoom"
      @mouseup="endZoom"
      :style="computedStyles"
    >
      <RingLoader v-if="isLoading" />
      <slot name='icon'></slot>
      <span class="button_label" v-html="label"></span>
    </button>
  </div>
</template>

<script>
import RingLoader from '../Loaders/RingLoader.vue';

export default {
  data() {
    return {
      isClicked: false
    }
  },
  components: {
    RingLoader,
  },
  props: {
    buttonType: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    customColor: {
      type: String,
      default: ''
    },
    isIconOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if(this.isLoading || this.isDisabled) return
      this.$emit('click');
    },
    startZoom() {
      if(this.isLoading || this.isDisabled) return
      this.isClicked = true
      document.addEventListener('mouseup', this.endZoom)
    },
    endZoom() {
      if(this.isLoading || this.isDisabled) return
      this.isClicked = false
      document.removeEventListener('mouseup', this.endZoom)
    }
  },
  computed: {
    computedStyles() {
      return {
        backgroundColor: this.customColor,
        padding: this.isIconOnly ? '12px' : '12px 24px'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.custom-button {
  cursor: pointer;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  transition: .2s;

  width: 100%;
  height: 48px;

  background: #FF565D;
  border-radius: 12px;

  &:focus-visible {
    box-shadow: 0px 0px 0px 2px #FFF, 0px 0px 0px 4px #121212;
  }
}
.custom-button:not(.isLoading):not(.isDisabled):hover {
  transform: scale(1.02);
  background-color: #E64C49;
}
.isLoading, .isDisabled {
  background: #FF9B99 !important;
}
.clicked {
  background: #BF3F3D !important;
  transform: scale(0.95) !important;
}
.button_label {
  font-family: 'Carnas';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;

  display: flex;
}

.ghost {
  background: transparent !important;
  border: 1px solid #121212;
  &:hover {
    background: rgba(0, 0, 0, 0.08) !important;
  }
  .button_label {
    color: #121212 !important;
  }
  .clicked {
    background: rgba(0, 0, 0, 0.16) !important;
  }
}
</style>